{
  "questions": [
    {
      "id": 1,
      "question": "在队伍落地时，你通常会选择什么样的位置？",
      "options": [
        { "id": "A", "text": "热门区域，人多的地方，快速获得击杀" },
        { "id": "B", "text": "中等热度区域，平衡风险和收益" },
        { "id": "C", "text": "偏远安全区域，优先发育装备" },
        { "id": "D", "text": "根据航线和队友意见灵活调整" }
      ]
    },
    {
      "id": 2,
      "question": "遇到敌方队伍时，你的第一反应是？",
      "options": [
        { "id": "A", "text": "立即冲锋，主动发起攻击" },
        { "id": "B", "text": "观察敌方装备和位置，寻找机会" },
        { "id": "C", "text": "尝试绕开，避免不必要的战斗" },
        { "id": "D", "text": "与队友沟通后决定行动方案" }
      ]
    },
    {
      "id": 3,
      "question": "在团战中，你更倾向于扮演什么角色？",
      "options": [
        { "id": "A", "text": "冲锋陷阵，吸引火力" },
        { "id": "B", "text": "输出核心，寻找击杀机会" },
        { "id": "C", "text": "后排支援，保护队友" },
        { "id": "D", "text": "指挥协调，控制节奏" }
      ]
    },
    {
      "id": 4,
      "question": "关于装备选择，你的优先级是？",
      "options": [
        { "id": "A", "text": "优先武器和弹药，快速提升战斗力" },
        { "id": "B", "text": "平衡护甲、武器和医疗用品" },
        { "id": "C", "text": "优先护甲和医疗，提高生存能力" },
        { "id": "D", "text": "根据当前局势和队伍需求调整" }
      ]
    },
    {
      "id": 5,
      "question": "在安全区缩圈时，你会？",
      "options": [
        { "id": "A", "text": "卡边追击落后的敌人" },
        { "id": "B", "text": "提前进圈，占据有利地形" },
        { "id": "C", "text": "跟随大部队，避免单独行动" },
        { "id": "D", "text": "根据装备情况和队伍状态决定" }
      ]
    },
    {
      "id": 6,
      "question": "队友被击倒时，你的行动是？",
      "options": [
        { "id": "A", "text": "立即冲上去救援，不惜代价" },
        { "id": "B", "text": "先清理周围敌人，再安全救援" },
        { "id": "C", "text": "等待安全时机，谨慎救援" },
        { "id": "D", "text": "评估风险后决定救援方式" }
      ]
    },
    {
      "id": 7,
      "question": "面对第三方介入的战斗，你会？",
      "options": [
        { "id": "A", "text": "继续战斗，同时对抗两支队伍" },
        { "id": "B", "text": "利用第三方，让敌人互相消耗" },
        { "id": "C", "text": "立即撤退，避免被夹击" },
        { "id": "D", "text": "根据自身状态和位置灵活应对" }
      ]
    },
    {
      "id": 8,
      "question": "在选择传奇角色时，你偏好？",
      "options": [
        { "id": "A", "text": "攻击型角色（如机器人、艾许）" },
        { "id": "B", "text": "侦察型角色（如密客、琉雀）" },
        { "id": "C", "text": "防御型角色（如纽卡索、守望者）" },
        { "id": "D", "text": "支援型角色（如命脉、罗芭）" }
      ]
    },
    {
      "id": 9,
      "question": "关于武器搭配，你更喜欢？",
      "options": [
        { "id": "A", "text": "双冲锋枪/霰弹枪，近距离爆发" },
        { "id": "B", "text": "狙击枪+冲锋枪，远近搭配" },
        { "id": "C", "text": "自动步枪+狙击枪，中远距离" },
        { "id": "D", "text": "根据地图和队伍配置选择" }
      ]
    },
    {
      "id": 10,
      "question": "在最终圈时，你的策略是？",
      "options": [
        { "id": "A", "text": "主动出击，清理所有敌人" },
        { "id": "B", "text": "占据制高点，控制局势" },
        { "id": "C", "text": "找掩体躲避，等待机会" },
        { "id": "D", "text": "根据剩余队伍数量调整策略" }
      ]
    },
    {
      "id": 11,
      "question": "发现敌人补给箱时，你会？",
      "options": [
        { "id": "A", "text": "立即冲过去抢夺" },
        { "id": "B", "text": "观察周围，设置埋伏" },
        { "id": "C", "text": "远远避开，不冒险" },
        { "id": "D", "text": "评估自身需求后决定" }
      ]
    },
    {
      "id": 12,
      "question": "队伍装备差距较大时，你倾向于？",
      "options": [
        { "id": "A", "text": "主动寻找战斗，快速提升装备" },
        { "id": "B", "text": "寻找落单敌人，降低风险" },
        { "id": "C", "text": "继续搜索，避免战斗" },
        { "id": "D", "text": "团队协作，共享资源" }
      ]
    },
    {
      "id": 13,
      "question": "听到远处枪声时，你的反应是？",
      "options": [
        { "id": "A", "text": "立即赶过去参与战斗" },
        { "id": "B", "text": "悄悄接近，寻找第三方机会" },
        { "id": "C", "text": "记住位置，但不主动接近" },
        { "id": "D", "text": "与队友商量后决定行动" }
      ]
    },
    {
      "id": 14,
      "question": "在高地争夺战中，你会？",
      "options": [
        { "id": "A", "text": "直接冲锋，强行占领" },
        { "id": "B", "text": "寻找侧翼路线，迂回包抄" },
        { "id": "C", "text": "放弃高地，寻找其他位置" },
        { "id": "D", "text": "利用技能和道具辅助攻坚" }
      ]
    },
    {
      "id": 15,
      "question": "面对装备更好的敌人时，你会？",
      "options": [
        { "id": "A", "text": "正面硬刚，靠技术取胜" },
        { "id": "B", "text": "利用地形和技能优势" },
        { "id": "C", "text": "避免交战，等待时机" },
        { "id": "D", "text": "团队配合，发挥数量优势" }
      ]
    },
    {
      "id": 16,
      "question": "关于游戏节奏，你更喜欢？",
      "options": [
        { "id": "A", "text": "快节奏，连续战斗" },
        { "id": "B", "text": "有计划的推进和战斗" },
        { "id": "C", "text": "稳健发育，后期发力" },
        { "id": "D", "text": "根据队伍状态调整节奏" }
      ]
    },
    {
      "id": 17,
      "question": "在队伍沟通中，你通常？",
      "options": [
        { "id": "A", "text": "积极指挥，推动进攻" },
        { "id": "B", "text": "提供信息，制定策略" },
        { "id": "C", "text": "听从指挥，配合行动" },
        { "id": "D", "text": "平衡各方意见，协调统一" }
      ]
    },
    {
      "id": 18,
      "question": "遇到技术更强的对手时，你会？",
      "options": [
        { "id": "A", "text": "正面挑战，提升自己" },
        { "id": "B", "text": "分析对手，寻找弱点" },
        { "id": "C", "text": "避免对抗，保存实力" },
        { "id": "D", "text": "团队协作，弥补个人不足" }
      ]
    },
    {
      "id": 19,
      "question": "关于游戏目标，你认为最重要的是？",
      "options": [
        { "id": "A", "text": "击杀数量，展现个人实力" },
        { "id": "B", "text": "战术执行，完美配合" },
        { "id": "C", "text": "生存时间，稳定发挥" },
        { "id": "D", "text": "团队胜利，共同进步" }
      ]
    },
    {
      "id": 20,
      "question": "在压力情况下，你的表现通常是？",
      "options": [
        { "id": "A", "text": "越战越勇，发挥更好" },
        { "id": "B", "text": "冷静分析，寻找突破" },
        { "id": "C", "text": "容易紧张，发挥失常" },
        { "id": "D", "text": "保持稳定，正常发挥" }
      ]
    },
    {
      "id": 21,
      "question": "当你的队伍处于劣势时，你会？",
      "options": [
        { "id": "A", "text": "孤注一掷，寻求翻盘机会" },
        { "id": "B", "text": "重新制定策略，寻找突破口" },
        { "id": "C", "text": "保守应对，等待对手失误" },
        { "id": "D", "text": "鼓励队友，保持团队士气" }
      ]
    },
    {
      "id": 22,
      "question": "面对空投补给时，你的态度是？",
      "options": [
        { "id": "A", "text": "第一时间冲过去，不管风险" },
        { "id": "B", "text": "观察周围情况，计算得失" },
        { "id": "C", "text": "通常不去，风险太大" },
        { "id": "D", "text": "看队伍装备需求再决定" }
      ]
    },
    {
      "id": 23,
      "question": "在建筑物内遭遇敌人时，你倾向于？",
      "options": [
        { "id": "A", "text": "直接冲进去硬刚" },
        { "id": "B", "text": "利用掩体和角度优势" },
        { "id": "C", "text": "退出建筑，拉开距离" },
        { "id": "D", "text": "使用技能和投掷物辅助" }
      ]
    },
    {
      "id": 24,
      "question": "关于游戏中的失误，你通常？",
      "options": [
        { "id": "A", "text": "立即尝试弥补，不惜冒险" },
        { "id": "B", "text": "快速调整策略，减少损失" },
        { "id": "C", "text": "承认失误，避免更大损失" },
        { "id": "D", "text": "与队友沟通，共同解决" }
      ]
    },
    {
      "id": 25,
      "question": "在队伍意见分歧时，你会？",
      "options": [
        { "id": "A", "text": "坚持自己的判断，说服队友" },
        { "id": "B", "text": "分析各方案的利弊" },
        { "id": "C", "text": "服从多数人的决定" },
        { "id": "D", "text": "寻求折中方案" }
      ]
    },
    {
      "id": 26,
      "question": "面对连续失败时，你的心态是？",
      "options": [
        { "id": "A", "text": "越挫越勇，更加激进" },
        { "id": "B", "text": "反思总结，调整策略" },
        { "id": "C", "text": "变得谨慎，避免风险" },
        { "id": "D", "text": "保持平常心，继续努力" }
      ]
    },
    {
      "id": 27,
      "question": "在选择战斗时机时，你更看重？",
      "options": [
        { "id": "A", "text": "敌人的血量和状态" },
        { "id": "B", "text": "地形和位置优势" },
        { "id": "C", "text": "自己队伍的安全" },
        { "id": "D", "text": "整体局势和圈形" }
      ]
    },
    {
      "id": 28,
      "question": "关于游戏中的运气成分，你认为？",
      "options": [
        { "id": "A", "text": "运气是实力的一部分，要敢于赌博" },
        { "id": "B", "text": "通过技巧和策略可以降低运气影响" },
        { "id": "C", "text": "运气很重要，要尽量避免不确定性" },
        { "id": "D", "text": "运气和实力并重，保持平衡" }
      ]
    },
    {
      "id": 29,
      "question": "在观看队友比赛时，你更关注？",
      "options": [
        { "id": "A", "text": "他们的击杀表现和操作" },
        { "id": "B", "text": "战术执行和决策过程" },
        { "id": "C", "text": "生存技巧和安全意识" },
        { "id": "D", "text": "团队配合和沟通效果" }
      ]
    },
    {
      "id": 30,
      "question": "对于游戏中的'苟'这种策略，你的看法是？",
      "options": [
        { "id": "A", "text": "太无聊了，游戏就是要战斗" },
        { "id": "B", "text": "是一种有效的战术选择" },
        { "id": "C", "text": "很实用，能提高胜率" },
        { "id": "D", "text": "看情况，有时候很有必要" }
      ]
    },
    {
      "id": 31,
      "question": "在队伍资源分配时，你会？",
      "options": [
        { "id": "A", "text": "优先自己，确保个人战斗力" },
        { "id": "B", "text": "根据角色定位合理分配" },
        { "id": "C", "text": "让给队友，自己凑合用" },
        { "id": "D", "text": "讨论后按需分配" }
      ]
    },
    {
      "id": 32,
      "question": "遇到明显的陷阱或埋伏时，你会？",
      "options": [
        { "id": "A", "text": "明知是陷阱也要硬闯" },
        { "id": "B", "text": "制定反埋伏计划" },
        { "id": "C", "text": "绕路避开，不冒险" },
        { "id": "D", "text": "观察等待，寻找机会" }
      ]
    },
    {
      "id": 33,
      "question": "在多队混战中，你的策略是？",
      "options": [
        { "id": "A", "text": "冲进去收割残血" },
        { "id": "B", "text": "在外围寻找最佳时机" },
        { "id": "C", "text": "远离战场，等待结束" },
        { "id": "D", "text": "根据队伍状态决定参与程度" }
      ]
    },
    {
      "id": 34,
      "question": "关于游戏中的信息收集，你认为？",
      "options": [
        { "id": "A", "text": "行动比信息更重要" },
        { "id": "B", "text": "信息是制胜的关键" },
        { "id": "C", "text": "过多信息会影响决策" },
        { "id": "D", "text": "适量信息配合直觉判断" }
      ]
    },
    {
      "id": 35,
      "question": "在面对未知敌人数量时，你会？",
      "options": [
        { "id": "A", "text": "直接冲上去探明情况" },
        { "id": "B", "text": "派人侦察后再行动" },
        { "id": "C", "text": "假设最坏情况，谨慎行事" },
        { "id": "D", "text": "根据声音和痕迹判断" }
      ]
    },
    {
      "id": 36,
      "question": "关于游戏中的心理战，你的态度是？",
      "options": [
        { "id": "A", "text": "用行动说话，不搞心理战" },
        { "id": "B", "text": "适当运用，增加胜算" },
        { "id": "C", "text": "容易被心理战影响" },
        { "id": "D", "text": "保持冷静，不受干扰" }
      ]
    },
    {
      "id": 37,
      "question": "在队友技术差距明显时，你会？",
      "options": [
        { "id": "A", "text": "独自行动，不拖累队友" },
        { "id": "B", "text": "指导队友，提升整体水平" },
        { "id": "C", "text": "迁就队友，降低难度" },
        { "id": "D", "text": "发挥各自优势，互补配合" }
      ]
    },
    {
      "id": 38,
      "question": "关于游戏中的创新战术，你的看法是？",
      "options": [
        { "id": "A", "text": "喜欢尝试新奇的打法" },
        { "id": "B", "text": "在稳定基础上适度创新" },
        { "id": "C", "text": "坚持传统有效的战术" },
        { "id": "D", "text": "根据对手调整战术风格" }
      ]
    },
    {
      "id": 39,
      "question": "在时间紧迫的情况下，你倾向于？",
      "options": [
        { "id": "A", "text": "快速决策，立即行动" },
        { "id": "B", "text": "简化分析，抓住要点" },
        { "id": "C", "text": "容易慌乱，决策失误" },
        { "id": "D", "text": "保持冷静，按部就班" }
      ]
    },
    {
      "id": 40,
      "question": "对于游戏中的'运营'概念，你的理解是？",
      "options": [
        { "id": "A", "text": "运营太慢，不如直接打架" },
        { "id": "B", "text": "运营是高级玩家的必备技能" },
        { "id": "C", "text": "运营很重要，但我不太会" },
        { "id": "D", "text": "运营和战斗要平衡发展" }
      ]
    },
    {
      "id": 41,
      "question": "在队伍缺少某种类型装备时，你会？",
      "options": [
        { "id": "A", "text": "主动出击抢夺敌人装备" },
        { "id": "B", "text": "调整战术适应现有装备" },
        { "id": "C", "text": "继续搜索直到找到合适装备" },
        { "id": "D", "text": "与队友协商重新分配装备" }
      ]
    },
    {
      "id": 42,
      "question": "面对网络延迟或卡顿时，你的应对方式是？",
      "options": [
        { "id": "A", "text": "继续正常游戏，靠预判弥补" },
        { "id": "B", "text": "调整打法，避免高风险操作" },
        { "id": "C", "text": "变得更加谨慎，减少主动出击" },
        { "id": "D", "text": "提醒队友注意配合节奏" }
      ]
    },
    {
      "id": 43,
      "question": "关于游戏中的'节奏控制'，你认为？",
      "options": [
        { "id": "A", "text": "快节奏才能压制对手" },
        { "id": "B", "text": "根据局势灵活调整节奏" },
        { "id": "C", "text": "慢节奏更稳妥安全" },
        { "id": "D", "text": "跟随队友的节奏" }
      ]
    },
    {
      "id": 44,
      "question": "在观察敌人战斗时，你最关注什么？",
      "options": [
        { "id": "A", "text": "他们的血量和技能使用情况" },
        { "id": "B", "text": "战斗的位置和地形利用" },
        { "id": "C", "text": "双方的装备差距" },
        { "id": "D", "text": "介入的最佳时机" }
      ]
    },
    {
      "id": 45,
      "question": "关于游戏中的'预判'能力，你的水平是？",
      "options": [
        { "id": "A", "text": "经常能准确预判敌人行动" },
        { "id": "B", "text": "有时准有时不准" },
        { "id": "C", "text": "预判能力较弱，主要靠反应" },
        { "id": "D", "text": "更依赖队友的信息和判断" }
      ]
    },
    {
      "id": 46,
      "question": "在队伍被分散时，你的优先考虑是？",
      "options": [
        { "id": "A", "text": "立即寻找机会重新集合" },
        { "id": "B", "text": "先确保自己安全再考虑汇合" },
        { "id": "C", "text": "利用分散优势进行骚扰" },
        { "id": "D", "text": "根据队友位置决定行动" }
      ]
    },
    {
      "id": 47,
      "question": "对于游戏中的'声音信息'，你的利用程度是？",
      "options": [
        { "id": "A", "text": "主要依靠视觉，声音是辅助" },
        { "id": "B", "text": "声音信息很重要，经常依赖" },
        { "id": "C", "text": "声音信息容易让我分心" },
        { "id": "D", "text": "会听但不是很敏感" }
      ]
    },
    {
      "id": 48,
      "question": "在面对明显实力更强的队伍时，你会？",
      "options": [
        { "id": "A", "text": "正面硬刚，学习他们的技巧" },
        { "id": "B", "text": "寻找他们的弱点和失误" },
        { "id": "C", "text": "尽量避免正面交锋" },
        { "id": "D", "text": "团队配合弥补个人实力差距" }
      ]
    },
    {
      "id": 49,
      "question": "关于游戏中的'位置感'，你认为自己？",
      "options": [
        { "id": "A", "text": "位置感很好，很少迷路" },
        { "id": "B", "text": "一般水平，偶尔会搞错方向" },
        { "id": "C", "text": "位置感较差，经常依赖队友" },
        { "id": "D", "text": "通过地图和标记来弥补" }
      ]
    },
    {
      "id": 50,
      "question": "在游戏的不同阶段，你的策略重点是？",
      "options": [
        { "id": "A", "text": "始终保持进攻性，不管阶段" },
        { "id": "B", "text": "前期发育，中后期主动出击" },
        { "id": "C", "text": "前期保守，后期看情况" },
        { "id": "D", "text": "根据队伍状态灵活调整" }
      ]
    }
  ]
}
